export const resizeImageCF = (url, size) => {
  // if url doesn't include original
  if (!url || !url.includes("original")) return url;
  return url.replace("original", `w=${size}`);
};
